// client/src/components/order/OrderTimeline.js
import React from 'react';
import { Check, Clock, Package, Truck, CheckCircle, XCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const fullSteps = [
  { key: 'pending', icon: Clock },
  { key: 'confirmed', icon: Check },
  { key: 'preparing', icon: Package },
  { key: 'inTransit', icon: Truck },
  { key: 'delivered', icon: CheckCircle },
];

const simpleSteps = [
  { key: 'placed', icon: Clock },
  { key: 'completed', icon: CheckCircle },
];

const fullStatusIndex = {
  pending: 0,
  confirmed: 1,
  preparing: 2,
  processing: 2, // alias
  inTransit: 3,
  shipped: 3, // alias
  in_transit: 3,
  delivered: 4,
};

const simpleStatusIndex = {
  pending: 0,
  delivered: 1,
};

const OrderTimeline = ({ status, isSimple = false }) => {
  const { t } = useTranslation('common');
  const isCancelled = status === 'cancelled';
  const steps = isSimple ? simpleSteps : fullSteps;
  const statusIndex = isSimple ? simpleStatusIndex : fullStatusIndex;
  const currentIdx = statusIndex[status] ?? -1;

  if (isCancelled) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-red-50 rounded-lg">
        <XCircle className="w-5 h-5 text-red-500" />
        <span className="text-sm font-medium text-red-700">{t('orderTimeline.cancelled', 'Order Cancelled')}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center w-full">
      {steps.map((step, idx) => {
        const StepIcon = step.icon;
        const isPast = idx < currentIdx;
        const isCurrent = idx === currentIdx;
        const isFuture = idx > currentIdx;

        return (
          <React.Fragment key={step.key}>
            <div className="flex flex-col items-center">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
                  isPast ? 'bg-green-500 text-white' :
                  isCurrent ? 'bg-blue-600 text-white ring-4 ring-blue-100' :
                  'bg-gray-200 text-gray-400'
                }`}
              >
                {isPast ? <Check className="w-4 h-4" /> : <StepIcon className="w-4 h-4" />}
              </div>
              <span className={`mt-1 text-[10px] sm:text-xs font-medium ${
                isCurrent ? 'text-blue-700' : isPast ? 'text-green-700' : 'text-gray-400'
              }`}>
                {t(`orderTimeline.${step.key}`, step.key)}
              </span>
            </div>
            {idx < steps.length - 1 && (
              <div className={`flex-1 h-0.5 mx-1 ${idx < currentIdx ? 'bg-green-500' : 'bg-gray-200'}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default OrderTimeline;
